import { Controller } from "@hotwired/stimulus";
import throttle from "lodash.throttle"; // Or implement your own throttle

export default class extends Controller {
    static targets = ["status"];
    static values = { timeout: Number }; // Timeout in minutes

    connect() {
        this.currentState = "offline";
        this.startEventListeners();
        this.recordActivity();
        this.heartbeatTimer = window.setInterval(() => this.heartbeat(), 30 * 1000);
    }

    disconnect() {
        this.clearTimers();
        window.clearInterval(this.heartbeatTimer);
        this.stopEventListeners();
    }

    startEventListeners() {
        this.handleUserActivity = throttle(() => this.recordActivity(), 1000);
        this.handleVisibilityChange = () => {
            if (document.hidden) {
                this.transitionTo("away");
            } else {
                this.recordActivity();
            }
        };
        this.handlePresenceConnected = () => this.heartbeat();

        document.addEventListener("mousemove", this.handleUserActivity);
        document.addEventListener("touchstart", this.handleUserActivity);
        document.addEventListener("keydown", this.handleUserActivity);
        document.addEventListener("scroll", this.handleUserActivity, { passive: true });
        document.addEventListener("visibilitychange", this.handleVisibilityChange);
        window.addEventListener("presenceConnected", this.handlePresenceConnected);
    }

    stopEventListeners() {
        document.removeEventListener("mousemove", this.handleUserActivity);
        document.removeEventListener("touchstart", this.handleUserActivity);
        document.removeEventListener("keydown", this.handleUserActivity);
        document.removeEventListener("scroll", this.handleUserActivity);
        document.removeEventListener("visibilitychange", this.handleVisibilityChange);
        window.removeEventListener("presenceConnected", this.handlePresenceConnected);
    }

    recordActivity() {
        if (document.hidden) return;

        this.transitionTo("online");
        this.scheduleInactivityTimers();
    }

    scheduleInactivityTimers() {
        this.clearTimers();

        this.awayTimer = window.setTimeout(() => this.transitionTo("away"), this.timeoutValue * 60 * 1000);
        this.offlineTimer = window.setTimeout(() => this.transitionTo("offline"), this.timeoutValue * 60 * 1000 * 2);
    }

    heartbeat() {
        if (this.currentState === "online" || this.currentState === "away") {
            this.dispatchStatus(this.currentState);
        }
    }

    transitionTo(status) {
        if (this.currentState === status) return;

        this.currentState = status;
        this.dispatchStatus(status);
    }

    clearTimers() {
        window.clearTimeout(this.awayTimer);
        window.clearTimeout(this.offlineTimer);
    }

    setOnline() {
        this.recordActivity();
    }

    setAway() {
        this.transitionTo("away");
    }

    setOffline() {
        this.transitionTo("offline");
    }

    dispatchStatus(status) {
        const eventName = {
            online: "userOnline",
            away: "userAway",
            offline: "userOffline"
        }[status];

        window.dispatchEvent(new CustomEvent(eventName));
    }
}
